/*
 *###############################################################################
 *Module Name                   : ProductRefContent.js                          #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Wednesday, September 8th 2021, 11:45:23 am    #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useEffect, useState } from "react"
import { Button, CardText, Col, Input, Label, Row } from "reactstrap"
import DPTextBox from "../../../framework/components/DPTextBox"
import { useContext } from "react";
import { Context } from "app-contexts/CommonContexts";
import DPDropDown from "framework/components/DPDropDown";

const ProductRefContent = ({
  Ref_Reference1,
  Ref_Reference1_OnChange,
  Ref_Reference1_Enabled,
  Ref_Reference2,
  Ref_Reference2_OnChange,
  Ref_Reference2_Enabled,
  Ref_Reference3,
  Ref_Reference3_OnChange,
  Ref_Reference3_Enabled,
  Ref_Reference4,
  Ref_Reference4_OnChange,
  Ref_Reference4_Enabled,
  Ref_Reference5,
  Ref_Reference5_OnChange,
  Ref_Reference5_Enabled,
  innerCaseSizes,
  setInnerCaseSizes,
  disabled,
  HandleClearStatus
}) => {

  const {
    txnDecimalAmt, pluRef1, pluRef2, pluRef3, pluRef4, pluRef5
  } = useContext(Context);

  const [innerCaseSize, setInnerCaseSize] = useState(1)


  useEffect(() => {
    setInnerCaseSize(1)
  }, [HandleClearStatus])




  const dropdownList = generateNumberArray()

  function generateNumberArray() {
    const numbers = []
    for (let i = 1; i <= 100; i++) {
      numbers.push({ value: i, label: `${i}` })
    }
    return numbers
  }



  return (
    <React.Fragment>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText={pluRef1 ? pluRef1 : "Reference Code 1"}
                    textType="text"
                    maxLength="40"
                    value={Ref_Reference1}
                    onChange={Ref_Reference1_OnChange}
                    disabled={Ref_Reference1_Enabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText={pluRef2 ? pluRef2 : "Reference Code 2"}
                    textType="text"
                    maxLength="40"
                    value={Ref_Reference2}
                    onChange={Ref_Reference2_OnChange}
                    disabled={Ref_Reference2_Enabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText={pluRef3 ? pluRef3 : "Reference Code 3"}
                    textType="text"
                    maxLength="40"
                    value={Ref_Reference3}
                    onChange={Ref_Reference3_OnChange}
                    disabled={Ref_Reference3_Enabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText={pluRef4 ? pluRef4 : "Reference Code 4"}
                    textType="text"
                    maxLength="40"
                    value={Ref_Reference4}
                    onChange={Ref_Reference4_OnChange}
                    disabled={Ref_Reference4_Enabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText={pluRef5 ? pluRef5 : "Reference Code 5"}
                    textType="text"
                    maxLength="40"
                    value={Ref_Reference5}
                    onChange={Ref_Reference5_OnChange}
                    disabled={Ref_Reference5_Enabled}
                  />
                </Col>

              </Row>
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                  <br></br>
                  <br></br>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-3 col-form-label-sm`}
                  >
                    Inner Case Sizes
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">

                  <DPDropDown
                    optionGroup={dropdownList}
                    selectedGroup={innerCaseSize}
                    onChange={(e) => {
                      setInnerCaseSize(e["value"])
                    }}
                    labelText={"Select Inner Case Size"}
                    disabled={disabled}
                  />

                  <table className="table table-bordered table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {innerCaseSizes.map((item, index) => (
                        <tr key={index}>
                          <td>{item.size}</td>
                          <td>
                            <Button
                              id="csizeDelBtn"
                              color="danger"
                              className="btn btn-danger"
                              size="sm"
                              disabled={disabled ? true : !item.isNew}
                              onClick={() => {
                                setInnerCaseSizes((prevSizes) =>
                                  prevSizes.filter((_, i) => i !== index)
                                )
                              }}
                            >
                              <i
                                className="mdi mdi-delete"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>


                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>

                </Col>
                <Col sm={12} md={6} className="mb-4-sm">
                  <Button
                    id="csizeAddBtn"
                    color="primary"
                    className="btn btn-primary"
                    size="sm"
                    disabled={disabled}
                    onClick={() => {

                      const existingSize = innerCaseSizes.find(
                        (size) => size.size === innerCaseSize
                      )
                      if (existingSize) {
                        return
                      }

                      setInnerCaseSizes((prevSizes) => [
                        ...prevSizes,
                        { size: innerCaseSize, isNew: true },
                      ])
                      setInnerCaseSize(1)


                    }}
                  >
                    <i
                      className="mdi mdi-plus-circle"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>

                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
    </React.Fragment>
  )
}
export default ProductRefContent
